import script from "./ProcessPanelGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessPanelGroup.vue?vue&type=script&setup=true&lang=js"

import "./ProcessPanelGroup.vue?vue&type=style&index=0&id=115e9c48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115e9c48"]])

export default __exports__